"use client";
import { Box, Flex, Heading } from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import {
  EnterpriseContactForm,
  EnterpriseContactFormProps,
} from "@ui/application/enterprise-contact-form";
import { customRichText } from "components/individuals/mdx-components";

export interface EnterpriseContactSectionProps {
  section: {
    title: string;
    content: any;
    bg: string;
    textColor: string;
    titleColor: string;
  };
  contactForm: EnterpriseContactFormProps;
}

export const EnterpriseContactSection = ({
  section,
  contactForm,
}: EnterpriseContactSectionProps) => {
  return (
    <Flex
      flexDir={{
        base: "column",
        lg: "row",
      }}
    >
      <Box
        bg={section.bg}
        px={{
          base: 8,
          lg: 32,
        }}
        pt={{
          base: 10,
          md: 14,
          lg: 20,
        }}
        pb={{
          base: 5,
          md: 9,
          lg: 20,
        }}
        w={{
          lg: "50%",
        }}
      >
        <Heading
          as={"h1"}
          color={section.titleColor}
          fontSize={{
            base: 26,
            md: 30,
            lg: 44,
            xl: 48,
          }}
          lineHeight={{
            base: 1.1,
            lg: 1.2,
          }}
        >
          {section.title}
        </Heading>
        <RichText
          content={section.content.raw}
          renderers={customRichText(section.textColor, 5)}
        />
      </Box>
      <EnterpriseContactForm {...contactForm} />
    </Flex>
  );
};
